// eslint-disable-next-line @typescript-eslint/no-empty-function
export async function asyncNoop() {}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function noop(..._: unknown[]) {}
